// Configuration

const state = {
  currentMarket: document.querySelector('body[data-country]')?.dataset.country.toUpperCase() == 'CA' ? 'CA' : 'US',
  currentLanguage: document.documentElement.lang.toUpperCase(),
  shopUrl: "https://kaseme-dev-page.myshopify.com",
  accessToken: "a815422836370e8d05bd0c6a813dbaa5"// Valeur par défaut
};

// Utilitaires
class CookieManager {
  static setCookie(name, value, days = 14) {
    const maxAge = days * 24 * 60 * 60;
    document.cookie = `${name}=${value}; path=/; max-age=${maxAge};`;
  }

  static getCookie(name) {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(name + '='))
      ?.split('=')[1];
  }
}

// Fonctions de construction des requêtes GraphQL
function buildQuery(first = 4, queryFilter) {
 let query = `
    query FilteredProducts @inContext(country: ${state.currentMarket},language: ${state.currentLanguage}) {
      products(first: ${first} query:"${queryFilter}", sortKey: BEST_SELLING) {
        edges {
          node {
            id
            handle
            title
            productType
            createdAt
            tags
            metafield(namespace: "custom_fields", key: "related_products") {
              value
            }
            featuredImage {
              url
              altText
              id
            }
            priceRange {
              maxVariantPrice {
                amount
                currencyCode
              }
              minVariantPrice {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  `;
  //console.log(query);
  return query;
}

function buildEnsembleQuery(first = 4, queryFilter, productId) {
  return `
     query FilteredProducts @inContext(country: ${state.currentMarket},language: ${state.currentLanguage}) {
       products(first: ${first} query:"(tags:ensemble:${queryFilter} AND NOT id:${productId})", sortKey: BEST_SELLING) {
         edges {
           node {
             id
             handle
             title
             productType
             createdAt
             tags
             featuredImage {
               url
               altText
               id
             }
             priceRange {
               maxVariantPrice {
                 amount
                 currencyCode
               }
               minVariantPrice {
                 amount
                 currencyCode
               }
             }
           }
         }
       }
     }
   `;
}

function buildComplementaryQuery(first = 4, queryFilter) {
  let query =  `
     query FilteredProducts @inContext(country: ${state.currentMarket},language: ${state.currentLanguage}) {
       products(first: ${first} query:${queryFilter}, sortKey: BEST_SELLING) {
         edges {
           node {
             id
             handle
             title
             productType
             createdAt
             tags
             featuredImage {
               url
               altText
               id
             }
            variants(first:50) {
              edges {
                node {
                  id
                  metafield(namespace: "custom", key: "phone_model") {
                    value
                  }
                }
              }
            }
             priceRange {
               maxVariantPrice {
                 amount
                 currencyCode
               }
               minVariantPrice {
                 amount
                 currencyCode
               }
             }
           }
         }
       }
     }
   `;
   //console.log(query);
   return query;
}

function  buildImage(currentProduct) {
  let imageurl = currentProduct.featuredImage ? currentProduct.featuredImage.url : '';
  let imagealt = currentProduct.featuredImage ? currentProduct.featuredImage.altText : '';
  let imageSection = '';
  if (imageurl == '') {
    imageSection = `<div class="card__media">
        <div class="media media--transparent media--hover-effect --missing-image">
          <img src="//www.kasemedesign.ca/cdn/shop/t/187/assets/pastille_loading.gif?v=144754221124087334011732548501" alt="loading" width="75" height="75">
        </div>
    </div>`;
  } else {
    imageSection = `<div class="card__media">
        <div class="media media--transparent media--hover-effect">
          <picture>
            <source media="(min-width:750px)" srcset="${imageurl}&width=300, ${imageurl}&width=600 1.5x">
            <source media="(max-width:749px)" srcset="${imageurl}&width=350, ${imageurl}&width=700 1.5x">
            <img src="${imageurl}&width=300" alt="${imagealt}">
          </picture>
        </div>
    </div>`;
  }
  return imageSection;
}

// Fonction pour construire le HTML d'un produit
function buildProductHtml(product) {
  const { id, title, handle, variantBySelectedOptions, tags, productType, price, priceRange, metafield, variants } = product;

  let variantId = variantBySelectedOptions ? variantBySelectedOptions.id.replace("gid://shopify/ProductVariant/", "") : null;
  if(productType == "Screen Protector" || productType == "Camera Lens") {
    const currentPhoneModel = document.querySelector('[data-phone-model]').dataset.phoneModel
    if(currentPhoneModel != "") {
      let activeVariants = variants.edges.find(edge => {
        let phoneModels = edge.node.metafield ? edge.node.metafield.value : '';
        if(phoneModels) {
          let ctr = '\"';
          phoneModels = phoneModels.replaceAll(ctr, '');
          ctr = "["
          phoneModels = phoneModels.replaceAll(ctr, '');
          ctr = "]";
          phoneModels = phoneModels.replaceAll(ctr, '');
          phoneModels.split(',').forEach(phoneModel => {
            if(phoneModel == currentPhoneModel) {
              variantId = edge.node.id.replace("gid://shopify/ProductVariant/","");
              return true;
            }
          })
        }
        return false;
      })
    }
    
  }
  
  let productUrl = handle
  if(variantId) {
      productUrl = productUrl + '?variant=' + variantId;
  }

  let new_title = title 

  if (new_title.indexOf("Clear Case") >= 0) {
    new_title = new_title.substring(0, new_title.indexOf("Clear Case"))
  }
  if (new_title.indexOf("AirPods Case") >= 0) {
    new_title = new_title.substring(0, new_title.indexOf("AirPods Case"))
  }
  if (new_title.indexOf(" iPad Folio") >= 0) {
    new_title = new_title.substring(0, new_title.indexOf(" iPad Folio"))
  }
  if (new_title.indexOf("MacBook skin") >= 0) {
    new_title = new_title.substring(0, new_title.indexOf("MacBook skin"))
  }
  if (new_title.indexOf(" Folio Case") >= 0) {
    new_title = new_title.substring(0, new_title.indexOf(" Folio Case"))
  }
console.log('state.currentLanguage:', state.currentLanguage);
  let preprice = state.currentLanguage == 'FR' ? 'À partir de' : 'FROM';
  if(priceRange.maxVariantPrice.amount == priceRange.minVariantPrice.amount) {
    preprice = ''
  } else if (productType.indexOf('iPad') > -1) {
    preprice = ''
  }
  let urlPrefix = state.currentLanguage == 'FR' ? '/fr' : '';

  let newBadge = '';
  let colorLabel = '';
  let newTag = tags.filter(tag => {
    return tag == 'New'
  })
  
  if(newTag.length > 0) {
    newBadge = state.currentLanguage == 'FR' ? '<span class="badge">Nouveau</span>':'<span class="badge">New</span>'
  }

  const quickAddLabel = state.currentLanguage == 'FR' ? 'Ajout rapide':'Quick Add'
  if(metafield && metafield.value) {
    if (state.currentLanguage == 'FR') {
      colorLabel = `<div class="card__label">Plus de couleurs disponibles</div>`
    } else {
      colorLabel = `<div class="card__label">More colors available</div>`
    }
  }

  const productID = id.replace("gid://shopify/Product/", "")
  let quickAdd = `<div class="quick-add no-js-hidden">
      <modal-opener data-modal="#QuickAdd-${productID}">
        <button id="quick-add-template--${productID}-submit" 
          type="submit" name="add" 
          class="quick-add__submit button button--full-width button--outline" aria-haspopup="dialog" 
          aria-labelledby="quick-add-template--${productID} title-template--${productID}" 
          data-product-url="${urlPrefix}/products/${productUrl}">
          ${quickAddLabel}
          <div class="loading__spinner hidden">
            <img src="//www.kasemedesign.ca/cdn/shop/t/189/assets/pastille_loading.gif?v=144754221124087334011732547761" alt="loading" width="75" height="75">
          </div>
        </button>
      </modal-opener>
      <quick-add-modal id="QuickAdd-${productID}" class="quick-add-modal">
        <div
          role="dialog"
          aria-label="${new_title}"
          aria-modal="true"
          class="quick-add-modal__content global-settings-popup"
          tabindex="-1"
        >
          <button
            id="ModalClose-${productID}"
            type="button"
            class="quick-add-modal__toggle button button--outline"
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" viewBox="0 0 18 17">
              <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor">
            </svg>
          </button>
          <div id="QuickAddInfo-${productID}" class="quick-add-modal__content-info"></div>
        </div>
      </quick-add-modal>
    </div>`;

  let enPriceTag = state.currentLanguage == 'EN' ? '$' : '';
  let frPriceTag = state.currentLanguage == 'FR' ? '$' : '';

  return `
    <li class="grid__item">
      <div class="card-wrapper product-card-wrapper underline-links-hover">
        <a href="${urlPrefix}/products/${productUrl}">
          <span class="visually-hidden">${new_title}</span>
        </a>
        <div class="card card--standard card--media">
          <div class="card__inner">
            ${buildImage(product)}
          </div>
          <div class="card__content">
            <div class="card__information">
              <h3 class="card__heading">
                <a href="${productUrl}" class="full-unstyled-link">
                  ${new_title}
                </a>
              </h3>
              <div class="card-information">
                <div class="price">
                  <div class="price__container">
                    <div class="price__regular">
                      ${preprice} ${enPriceTag}${productType.indexOf('Phone Case') > -1 ? priceRange.maxVariantPrice.amount : priceRange.minVariantPrice.amount}${frPriceTag}
                    </div>
                  </div>
                </div>
                ${colorLabel}
              </div>
            </div>
            <!--${quickAdd}-->
          </div>
          <div class="card__badge top left">
            ${newBadge}
          </div>
        </div>
      </div>
    </li>
  `;
}


// Fonction de fetch principale
async function fetchProductByTitle(productTitle, productId, productType) {
  try {
    let impactQuery = productType == "Phone Case" ? "" : `(title:${productTitle}) OR `;
    let airPodsQuery = productType == "Airpod Cases" ? "" : `(title:${productTitle} AirPods Case) OR `;
    let skinQuery = productType == "Skin" ? "" : `(title:${productTitle} MacBook Skin) OR `;
    let clearCaseQuery = productType == "Clear Case" ? "" : `(title:${productTitle} Clear Case) OR `;
    let iPadFolioQuery = productType == "iPad Folio Case" ? "" : `(title:${productTitle} iPad Folio) OR `;
    let iPadClearCaseQuery = productType == "iPad Clear Case" ? "" : `(title:${productTitle} iPad Clear Case) OR `;
    let queryFilter = `${impactQuery}${airPodsQuery}${skinQuery}${clearCaseQuery}${iPadFolioQuery}${iPadClearCaseQuery}AND NOT id:${productId}`
    queryFilter = queryFilter.slice(0, queryFilter.lastIndexOf(' OR')) + queryFilter.slice(queryFilter.lastIndexOf(' OR') + 3);
    let query = buildQuery(10, queryFilter);

    const response = await fetch(state.shopUrl + '/api/2025-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': state.accessToken
      },
      body: JSON.stringify({
        query: query
      })
    });

    if (!response.ok) throw new Error('Network response was not ok');
    const data = await response.json();
    let products = data.data?.products;
    return products;
  } catch (error) {
    console.error('Error fetching products:', error);
    return false;
  }
}

// Fonction de fetch principale
async function fetchProductEnsemble(missingProducts, ensemble, productType) {
  try {
    //let query = buildEnsembleQuery(missingProducts, ensemble, productId);
    let queryFilter = "";
    if(ensemble != '' && productType == "Phone Case") {
      const capitalized = ensemble.charAt(0).toUpperCase() + ensemble.slice(1)
      queryFilter = `"(name:Phone Loop ${capitalized}) OR (name:Crossbody Phone Strap ${capitalized})`;
      if(missingProducts > 2) {
        queryFilter += ` OR (name:Screen Protector) OR (name:Camera lens protector)"`;
      } else {
        queryFilter += `"`;
      }
    } else {
      queryFilter = ` (name:Screen Protector) OR (name:Camera lens protector)"`;
    }
    let query = buildComplementaryQuery(missingProducts, queryFilter);

    const response = await fetch(state.shopUrl + '/api/2025-01/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': state.accessToken
      },
      body: JSON.stringify({
        query: query
      })
    });

    if (!response.ok) throw new Error('Network response was not ok');
    const data = await response.json();
    let products = data.data?.products;
    return products;
  } catch (error) {
    console.error('Error fetching products:', error);
    return false;
  }
}

// Initialisation
document.addEventListener('DOMContentLoaded', async  () => {
  const section = document.querySelector(`[data-complete-look]`);
  if (!section) {
    console.warn(`Section ${currentBuild} not found`);
    return;
  }
  const productTitle = section?.dataset.productTitle;
  const productId = section?.dataset.productId;
  const productType = section?.dataset.productType;
  const hasColorVariant = section?.dataset.hasColorVariant;
  let comparatifTitle =  productTitle.replace(' AirPods Case', '');
  comparatifTitle = comparatifTitle.replace(' MacBook Skin', '');
  comparatifTitle = comparatifTitle.replace(' Clear Case', '');
  comparatifTitle = comparatifTitle.replace(' iPad Folio', '');
  comparatifTitle = comparatifTitle.replace(' iPad Clear Case', '');
  comparatifTitle = comparatifTitle.replace(' Folio Case', '');

  let sameProductDesignList = await fetchProductByTitle(productTitle, productId, productType, hasColorVariant);
  let productDesignList = [];
  if(sameProductDesignList && sameProductDesignList.edges.length > 0) {
    productDesignList = sameProductDesignList.edges.filter(edge => {
      if(edge.node.productType != productType && edge.node.title != comparatifTitle) {
        let sameProductTitle =  edge.node.title.replace(' AirPods Case', '');
        sameProductTitle = sameProductTitle.replace(' MacBook Skin', '');
        sameProductTitle = sameProductTitle.replace(' Clear Case', '');
        sameProductTitle = sameProductTitle.replace(' iPad Folio', '');
        sameProductTitle = sameProductTitle.replace(' iPad Clear Case', '');
        sameProductTitle = sameProductTitle.replace(' Folio Case', '');
        sameProductTitle = sameProductTitle.replace(comparatifTitle, '');
        sameProductTitle = sameProductTitle.replace(' ', '');
      
        if(sameProductTitle.length == 0) {
          return true;
        }
      }
      return false;
    });
  }
  if (productDesignList?.length < 4) {
    const missingProducts = 4 - productDesignList?.length;
    const ensemble = section?.dataset.ensemble;
    if(productType == "Phone Case" || productType == "Folio Case" || productType == "Clear Case") {
      const ensembleProducts = await fetchProductEnsemble(missingProducts,ensemble, productType);
      if(ensembleProducts && ensembleProducts.edges.length > 0) {
        productDesignList.push(...ensembleProducts.edges);
      }
    }
  }
    
 //console.log('Products fetched:', products, products?.edges?.length);
  if(productDesignList && productDesignList.length > 0) {
    section.querySelector('ul').innerHTML = '';
    let productHTML = ''
    let counter = 0;
    productDesignList.forEach(({ node: product }) => {
      productHTML += buildProductHtml(product)
      counter++;
    });

    section.querySelector('ul').innerHTML += productHTML;
    if(counter == 0) {
      let parent = section.parentElement;
      let parentId = parent.id
      document.querySelector('[href="#' + parentId + '"]').remove();
      parent.remove();
    }    
  } else {
    let parent = section.parentElement;
    let parentId = parent.id
    document.querySelector('[href="#' + parentId + '"]').remove();
    parent.remove();
  }
});
